export { Color as Colors } from '@yanolja-rnd/ya-com-core';
